import React from 'react';
import PageList from '../../../components/PageListAPI'
import * as api from '../../../api/list'
import { useCan } from 'src/hooks/useCan';
import { SLUGS } from 'src/enum/permissions.enum';

export default function Position(props) {
  const can = useCan()
  return (
    <div className='App-paper'>
      <PageList
        name='position'
        title='Список должностей'
        columns={[{ id: 'name', name: 'Должность' }]}
        createItem={can(SLUGS.CATALOG.CREATE)}
        deleteItem={can(SLUGS.CATALOG.DELETE)}
        click={can(SLUGS.CATALOG.UPDATE)}
        loadAPI={{
          request: api.getPosition,
        }}
        deleteAPI={api.deletePosition}
        {...props}
      />
    </div>
  )
}